

function CardContainer(props) {
    return (
        <div className="cmp-card mb-40 mb-lg-4">
            <div className="card has-bkg-grey shadow-sm mb-0">
                <div className="card-header border-0 p-0 mb-lg-30">
                    <div className="d-flex">
                        <h2 className="title-xxlarge mb-1">{props.title}</h2>
                    </div>
                    {props?.description ?? ""}
                </div>
                {props.children}
            </div>
        </div>
    )

}


export default CardContainer;